
const palettes = [
  {
    name: 'NES',
    author: '',
    link: '',
    colors: [
      '000000', 'fcfcfc', 'f8f8f8', 'bcbcbc', '7c7c7c', 'a4e4fc',
      '3cbcfc', '0078f8', '0000fc', 'b8b8f8', '6888fc', '0058f8',
      '0000bc', 'd8b8f8', '9878f8', '6844fc', '4428bc', 'f8b8f8',
      'f878f8', 'd800cc', '940084', 'f8a4c0', 'f85898', 'e40058',
      'a80020', 'f0d0b0', 'f87858', 'f83800', 'a81000', 'fce0a8',
      'fca044', 'e45c10', '881400', 'f8d878', 'f8b800', 'ac7c00',
      '503000', 'd8f878', 'b8f818', '00b800', '007800', 'b8f8b8',
      '58d854', '00a800', '006800', 'b8f8d8', '58f898', '00a844',
      '005800', '00fcfc', '00e8d8', '008888', '004058', 'f8d8f8',
      '787878',
    ],
  },
  {
    name: 'Commodore 64',
    author: '',
    link: '',
    colors: [
      '000000', '626262', '898989', 'adadad',
      'ffffff', '9f4e44', 'cb7e75', '6d5412',
      'a1683c', 'c9d487', '9ae29b', '5cab5e',
      '6abfc6', '887ecb', '50459b', 'a057a3',
    ],
  },
  {
    name: 'GB Grey',
    author: '',
    link: '',
    colors: [
      '000000', '676767', 'b6b6b6', 'ffffff',
    ],
  },
  {
    name: 'GB Green',
    author: '',
    link: '',
    colors: [
      '081820', '346856', '88c070', 'e0f8d0',
    ],
  },
  {
    name: 'Endsaga 32',
    author: 'ENDSAGA',
    link: 'https://twitter.com/ENDESGA',
    colors: [
      'be4a2f', 'd77643', 'ead4aa', 'e4a672', 'b86f50',
      '733e39', '3e2731', 'a22633', 'e43b44', 'f77622',
      'feae34', 'fee761', '63c74d', '3e8948', '265c42',
      '193c3e', '124e89', '0099db', '2ce8f5', 'ffffff',
      'c0cbdc', '8b9bb4', '5a6988', '3a4466', '262b44',
      '181425', 'ff0044', '68386c', 'b55088', 'f6757a',
      'e8b796', 'c28569',
    ],
  },
  {
    name: 'DawnBringer 32',
    author: 'DawnBringer',
    link: '',
    colors: [
      '000000', '222034', '45283c', '663931', '8f563b',
      'df7126', 'd9a066', 'eec39a', 'fbf236', '99e550',
      '6abe30', '37946e', '4b692f', '524b24', '323c39',
      '3f3f74', '306082', '5b6ee1', '639bff', '5fcde4',
      'cbdbfc', 'ffffff', '9badb7', '847e87', '696a6a',
      '595652', '76428a', 'ac3232', 'd95763', 'd77bba',
      '8f974a', '8a6f30',
    ],
  },
  {
    name: 'DawnBringer 16',
    author: 'DawnBringer',
    link: '',
    colors: [
      '140c1c', '442434', '30346d', '4e4a4e',
      '854c30', '346524', 'd04648', '757161',
      '597dce', 'd27d2c', '8595a1', '6daa2c',
      'd2aa99', '6dc2ca', 'dad45e', 'deeed6',
    ],
  },
  {
    name: 'Sweetie 16',
    author: 'GrafxKid',
    link: '',
    colors: [
      '1a1c2c', '5d275d', 'b13e53', 'ef7d57',
      'ffcd75', 'a7f070', '38b764', '257179',
      '29366f', '3b5dc9', '41a6f6', '73eff7',
      'f4f4f4', '94b0c2', '566c86', '333c57',
    ],
  },
  {
    name: 'NA16',
    author: 'Nauris',
    link: '',
    colors: [
      '8c8fae', '584563', '3e2137', '9a6348',
      'd79b7d', 'f5edba', 'c0c741', '647d34',
      'e4943a', '9d303b', 'd26471', '70377f',
      '7ec4c1', '34859d', '17434b', '1f0e1c',
    ],
  },
  {
    name: 'Japanese Woodblock',
    author: 'Polyducks',
    link: 'https://twitter.com/Polyducks',
    colors: [
      '2b2821', '624c3c', 'd9ac8b', 'e3cfb4',
      '243d5c', '5d7275', '5c8b93', 'b1a58d',
      'b03a48', 'd4804d', 'e0c872', '3e6958',
    ],
  },
];

export default palettes;
